import { FormattedMessage } from 'react-intl';
import React from 'react';
import messages from './messages';
import './styles.css';
import Header from '../../components/Header';

const SubHeader = () => (
  <React.Fragment>
    <Header as="h3" styleName="left-aligned-full-width" data-cy="merit-scholarships-heading">
      <FormattedMessage {...messages.meritScholarshipsTitle} />
    </Header>
    <div styleName="left-aligned-full-width space" data-cy="merit-scholarships-message">
      <FormattedMessage {...messages.meritScholarshipsSubText} />
    </div>
    <div styleName="left-aligned-full-width space" data-cy="merit-scholarships-message">
      <b><FormattedMessage {...messages.meritScholarshipsGeneralInfoSubTitle} /></b>
    </div>
  </React.Fragment>
);

export default SubHeader;
